import { render, staticRenderFns } from "./DocumentChip.vue?vue&type=template&id=0dd023a6"
import script from "./DocumentChip.vue?vue&type=script&lang=js"
export * from "./DocumentChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports